import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  dialogSyncDevice: false,
  responseSyncDevice: [],
  syncDeviceButtonType: 'syncing', // 'syncing', 'done'
  filterSyncDeviceStatus: null,
  filterSyncDeviceHardware: null,
  itemsPerPageSyncDevice: 20,
  isFetchingSyncDevice: false,
  selectedSyncDeviceHardware: null,

  hardwares: [],
  totalHardwares: null,
  hardwareModels: [],
  organizations: [],
  employees: [],
  identifyModeVf1000: [],
  identifyModeVf1000r: [],
  identifyModeAcu01r: [],
  identifyModeVf600: [],
  identifyModeAcu81: [],
  identifyModeTat51i: [],
  identifyModeCru77rf: [],
  identifyModeQ3rac: [],
  deviceInfoTranslate: null,
  employeeInfoTranslate: null,
  employeeListTranslate: null,
  identifyModes: [],
}

export const mutations = {
  SET_DIALOG_SYNC_DEVICE(state, dialogSyncDevice) {
    state.dialogSyncDevice = dialogSyncDevice
  },
  SET_RESPONSE_SYNC_DEVICE(state, responseSyncDevice) {
    state.responseSyncDevice = responseSyncDevice
  },
  SET_SYNC_DEVICE_BUTTON_TYPE(state, syncDeviceButtonType) {
    state.syncDeviceButtonType = syncDeviceButtonType
  },
  SET_FILTER_SYNC_DEVICE_STATUS(state, filterSyncDeviceStatus) {
    state.filterSyncDeviceStatus = filterSyncDeviceStatus
  },
  SET_FILTER_SYNC_DEVICE_HARDWARE(state, filterSyncDeviceHardware) {
    state.filterSyncDeviceHardware = filterSyncDeviceHardware
  },
  SET_ITEMS_PER_PAGE_SYNC_DEVICE(state, itemsPerPageSyncDevice) {
    state.itemsPerPageSyncDevice = itemsPerPageSyncDevice
  },
  SET_IS_FETCHING_SYNC_DEVICE(state, isFetchingSyncDevice) {
    state.isFetchingSyncDevice = isFetchingSyncDevice
  },
  SET_SELECTED_SYNC_DEVICE_HARDWARE(state, selectedSyncDeviceHardware) {
    state.selectedSyncDeviceHardware = selectedSyncDeviceHardware
  },

  SET_IDENTIFY_MODES(state, identifyModes) {
    state.identifyModes = identifyModes
    // const hardwareModelCode = identifyModes[0]?.hardware_model_code
    // if (hardwareModelCode === 'vf1000') state.identifyModeVf1000 = identifyModes
    // if (hardwareModelCode === 'vf1000r')
    //   state.identifyModeVf1000r = identifyModes
    // if (hardwareModelCode === 'acu01r') state.identifyModeAcu01r = identifyModes
    // if (hardwareModelCode === 'vf600') state.identifyModeVf600 = identifyModes
    // if (hardwareModelCode === 'acu81') state.identifyModeAcu81 = identifyModes
    // if (hardwareModelCode === 'tat51i') state.identifyModeTat51i = identifyModes
    // if (hardwareModelCode === 'cru77rf')
    //   state.identifyModeCru77rf = identifyModes
    // if (hardwareModelCode === 'q3rac') state.identifyModeQ3rac = identifyModes
  },
  SET_TOTAL_HARDWARES(state, totalHardwares) {
    state.totalHardwares = totalHardwares
  },
  SET_HARDWARES(state, hardwares) {
    state.hardwares = hardwares
  },
  SET_HARDWARE_MODELS(state, hardwareModels) {
    state.hardwareModels = hardwareModels
  },
  EDIT_HARDWARE(state, hardware) {
    const index = state.hardwares.findIndex(
      (el) => el.hardware_uuid === hardware.hardware_uuid
    )
    if (index !== -1) {
      state.hardwares.splice(index, 1, hardware)
    }
  },
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations
  },
  SET_EMPLOYEES(state, employees) {
    state.employees = employees
  },
  SET_DEVICE_INFO_TRANSLATE(state, deviceInfoTranslate) {
    state.deviceInfoTranslate = deviceInfoTranslate
  },
  SET_EMPLOYEE_INFO_TRANSLATE(state, employeeInfoTranslate) {
    state.employeeInfoTranslate = employeeInfoTranslate
  },
  SET_EMPLOYEE_LIST_TRANSLATE(state, employeeListTranslate) {
    state.employeeListTranslate = employeeListTranslate
  },
}

export const actions = {
  fetchHardwareModels({ commit }, payload) {
    return ApiService.fetchHardwareModels(payload)
      .then((res) => {
        const hardwareModels = res.data.data
        commit('SET_HARDWARE_MODELS', hardwareModels)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchHardwaresSyncAll(_, payload) {
    return ApiService.fetchHardwares(payload)
      .then((res) => {
        const hardwares = res.data.data

        return hardwares
      })
      .catch((error) => {
        throw error
      })
  },
  fetchHardwares({ commit }, payload) {
    return ApiService.fetchHardwares(payload)
      .then((res) => {
        const hardwares = res.data.data

        commit('SET_HARDWARES', hardwares)
        commit('SET_TOTAL_HARDWARES', res.data.total)
        return hardwares
      })
      .catch((error) => {
        throw error
      })
  },
  fetchHardware(_, payload) {
    return ApiService.fetchHardware(payload)
      .then((res) => {
        const hardware = res.data
        return hardware
      })
      .catch((error) => {
        throw error
      })
  },
  editHardware({ commit }, hardware) {
    return ApiService.editHardware(hardware)
      .then((res) => {
        const hardware = res.data
        commit('EDIT_HARDWARE', hardware)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchCodes(_, hardware_model_code) {
    return ApiService.fetchCodes(hardware_model_code)
      .then((res) => {
        const results = res.data.data
        return results
      })
      .catch((error) => {
        throw error
      })
  },
  fetchJobs(_, payload) {
    return ApiService.fetchJobs(payload)
      .then((res) => {
        const results = res.data.data
        return results
      })
      .catch((error) => {
        throw error
      })
  },
  syncLogUnionSyncJob({ commit }, payload) {
    return ApiService.syncLogUnionSyncJob(payload)
      .then((res) => {
        const responseSyncDevice = res.data.data
        commit('SET_RESPONSE_SYNC_DEVICE', responseSyncDevice)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchJob(_, sync_job_uuid) {
    return ApiService.fetchJob(sync_job_uuid)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  cancelJob(_, hardware_uuid) {
    return ApiService.cancelJob(hardware_uuid).catch((error) => {
      throw error
    })
  },
  employeeLastUpdated(_, payload) {
    return ApiService.employeeLastUpdated(payload)
      .then((res) => {
        return res
      })
      .catch((error) => {
        throw error
      })
  },
  getLastUpdate(_, payload) {
    return ApiService.getLastUpdate(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  setFirmware(_, payload) {
    return ApiService.setFirmware(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  getDeviceInfo(_, payload) {
    return ApiService.getDeviceInfo(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  getDeviceLog(_, payload) {
    return ApiService.getDeviceLog(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  getEmployee(_, payload) {
    return ApiService.getEmployee(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  getEmployeeList(_, payload) {
    return ApiService.getEmployeeList(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  getAccessAuthorityList(_, payload) {
    return ApiService.getAccessAuthorityList(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  setEmployee(_, payload) {
    return ApiService.setEmployee(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  deleteEmployee(_, payload) {
    return ApiService.deleteEmployee(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  userAcknowledge(_, sync_job_uuid) {
    return ApiService.userAcknowledge(sync_job_uuid)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizationsWithQueryString({ commit }, payload) {
    return ApiService.fetchOrganizationsWithQueryString(payload)
      .then((res) => {
        const organizations = res.data.data
        commit('SET_ORGANIZATIONS', organizations)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeesWithQueryString({ commit }, payload) {
    return ApiService.fetchEmployeesWithQueryString(payload)
      .then((res) => {
        const employees = res.data.data
        commit('SET_EMPLOYEES', employees)
      })
      .catch((error) => {
        throw error
      })
  },
  getNetworkConfig(_, payload) {
    return ApiService.getNetworkConfig(payload)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  updateNetworkConfig(_, payload) {
    return ApiService.updateNetworkConfig(payload)
      .then(({ data }) => {
        return data
      })
      .catch((error) => {
        throw error
      })
  },
  fetchIdentifyMode({ commit }, payload) {
    return ApiService.fetchIdentifyMode(payload)
      .then(({ data }) => {
        commit('SET_IDENTIFY_MODES', data.data)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchIdentifyModes({ commit }, _) {
    return ApiService.fetchIdentifyModes()
      .then(({ data }) => {
        commit('SET_IDENTIFY_MODES', data.data)
      })
      .catch((error) => {
        throw error
      })
  },
  editIdentifyMode(_, payload) {
    return ApiService.editIdentifyMode(payload)
      .then((res) => {
        const results = res.data.data
        return results
      })
      .catch((error) => {
        throw error
      })
  },
  fetchProcessSyncJob(_, payload) {
    return ApiService.fetchProcessSyncJob(payload)
      .then((res) => {
        const result = res.data
        return result
      })
      .catch((error) => {
        throw error
      })
  },
  fetchDeviceInfoTranslate({ commit }) {
    return ApiService.fetchDeviceInfoTranslate()
      .then((res) => {
        const deviceInfoTranslate = res.data
        commit('SET_DEVICE_INFO_TRANSLATE', deviceInfoTranslate)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeInfoTranslate({ commit }) {
    return ApiService.fetchEmployeeInfoTranslate()
      .then((res) => {
        const employeeInfoTranslate = res.data
        commit('SET_EMPLOYEE_INFO_TRANSLATE', employeeInfoTranslate)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchEmployeeListTranslate({ commit }) {
    return ApiService.fetchEmployeeListTranslate()
      .then((res) => {
        const employeeListTranslate = res.data
        commit('SET_EMPLOYEE_LIST_TRANSLATE', employeeListTranslate)
      })
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {}
